import { render, staticRenderFns } from "./serienbriefe.vue?vue&type=template&id=712a570e&scoped=true&"
import script from "./serienbriefe.vue?vue&type=script&lang=js&"
export * from "./serienbriefe.vue?vue&type=script&lang=js&"
import style0 from "./serienbriefe.vue?vue&type=style&index=0&id=712a570e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a570e",
  null
  
)

export default component.exports